import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AuthTokenService} from "../../services/auth-token.service";
import {LoginService} from "../../services/login.service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup | any;
  visibilityPassword: boolean = false;
  public loading: boolean = false;
  public versaoApp: string = 'Carregando...';

  constructor(
    public formBuilder: FormBuilder,
    public router: Router,
    public authTokenService: AuthTokenService,
    public loginService: LoginService,
    private http: HttpClient
  ) {
    if (authTokenService.token !== '') {
      this.router.navigate(['/dashboard']);
    }

    this.loginForm = this.formBuilder.group({
      username: [null, Validators.compose([Validators.required])],
      password: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
    this.buscarVersaoDoServidor();
  }

  private buscarVersaoDoServidor() {
  const url = `/assets/version.json?t=${new Date().getTime()}`;

  this.http.get<any>(url).subscribe(
    (response: any) => { 
      if (response && response.version) {
        this.versaoApp = response.version;
      }
    },
    (error: any) => { 
      console.error('Erro ao buscar a versão:', error);
      this.versaoApp = 'Desconhecida';
    }
  );
}

  submit() {
    const username = this.loginForm.get('username').value.replace(/\D/g, '');
    const password = this.loginForm.get('password').value;

    this.loading = true;
    this.loginService.login(username, password).subscribe({
      next: (res) => {
        this.authTokenService.token = res.data;
        this.router.navigate(['/dashboard']);
        this.loading = false;
      },
      error: (err) => {
        // TODO: Exibir mensagem de erro para o usuário
        this.loading = false;
      }
    });
  }

  recoverPassword() {
    this.router.navigate(['/recover-password']);
  }

  viewPassword() {
    this.visibilityPassword = !this.visibilityPassword;
  }
}
